import { useEffect, useState } from "react";
import SideDrawerOverlay from "../SideOverLay";
import star from "../../assets/images/starrating.svg";
import emptyStar from "../../assets/images/emptyStar.svg";
import { Button } from "../../common/components/Button";
import { Button as MuiButton } from "../components/Common/Button";
import styles from "./index.module.scss";
import { postCall, putCall } from "../../services/apiService";
import { endPoints } from "../../constants/urlConstants";
import { RATING_KEYS } from "../../constants";
import UserCard from "../SeatApprovalFlow/SeekerDetailsOverlay/Common/UserCards";
import GrayLine from "../../common/components/GrayLine";
import { calculateOverallRating, getAverageRating } from "../../utils/commonFunctions";
const ReviewOverlay = ({
  open,
  onClose,
  onSave,
  seekerId,
  programId,
  initialRatings = {},
  initialComments = "",
  seekersData,
  disablePreferences,
  onRefresh
}: {
  open: boolean;
  onClose: () => void;
  onSave: (review: any) => void;
  seekerId?: number;
  programId?: number;
  initialRatings?: { [key: string]: { rating: number; id?: number } };
  initialComments?: string;
  seekersData?: unknown;
  disablePreferences
  onRefresh?: () => void;
}) => {
  const [ratings, setRatings] = useState<{
    [key: string]: { rating: number; id?: number };
  }>(initialRatings);
  const [comments, setComments] = useState(initialComments);


  console.log("ReviewOverlay initialRatings:", initialRatings);
  useEffect(() => {
    setRatings(initialRatings);
    setComments(initialComments);
  }, [initialRatings, initialComments]);

  const isFormValid = comments.trim().length > 0;

  // Determine if this is an update (edit) or a new review
  const isUpdate =
    !!initialComments &&
    initialComments.trim().length > 0 &&
    initialRatings &&
    Object.keys(initialRatings).length > 0;

  const resetForm = () => {
    setRatings(initialRatings);
    setComments(initialComments);
  };
  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSave = async () => {
    let ratingsArr;
    if (isUpdate) {
      // For update (PUT), include id if present
      ratingsArr = RATING_KEYS.map(({ key }) => ({
        ...(ratings[key]?.id ? { id: ratings[key].id } : {}),
        ratingKey: key,
        rating: Number(ratings[key]?.rating) ?? 0,      }));
    } else {
      // For new (POST), do not include id
      ratingsArr = RATING_KEYS.map(({ key }) => ({
        ratingKey: key,
        rating: typeof ratings[key]?.rating === "number" ? ratings[key].rating : 0,
      }));
    }

    const data = {
      ratings: ratingsArr,
      review: comments,
    };
    console.log("ReviewOverlay Save Payload:", JSON.stringify(data, null, 2));
    try {
      let response;
      if (isUpdate) {
        // Use PUT for update
        response = await putCall(
          endPoints.ratingForRegisteredSeekers(seekerId),
          data,
        );
      } else {
        // Use POST for new
        response = await postCall(
          endPoints.ratingForRegisteredSeekers(seekerId),
          data,
        );
      }
      if (response?.status && response.status >= 200 && response.status < 300) {
        onSave({ success: true });
          if (onRefresh) {
          onRefresh();
        }
        resetForm();
        handleClose(); // <-- Ensure overlay closes on both save and update
      } else {
        onSave({ success: false });
      }
    } catch (error) {
      onSave({ success: false });
    }
  };

  if (!open) return null;
  return (
    <SideDrawerOverlay
      open={open}
      grayLine={true}
      onClose={handleClose}
      headerText={isUpdate ? "Update review" : "Add review"}
     
      footer={
        <>
          <MuiButton
            variant="outline"
            className={styles.cancelButton}
            onClick={handleClose}
          >
            cancel
          </MuiButton>
          <Button
            buttonTextClassName={styles.saveButtonText}
            buttonClassName={styles.saveButton}
            onClick={handleSave}
            disable={!isFormValid}
          >
            {isUpdate ? "update" : "save"}
          </Button>
        </>
      }
    >

      <div className={styles.ratingForm}>
      {seekersData && ( 
        <UserCard seeker={seekersData} disablePreferences={true} />
       )} 
        <div>
          <div className={styles.filterlabelName}>Rating
            <GrayLine />
          </div>
          <div className={styles.totalRating}>
            Current rating is <span className={styles.ratingScore}>{getAverageRating(initialRatings)}</span>
          </div>
          {RATING_KEYS.map(({ label, key }) => (
            <div key={key} className={styles.ratingRow}>
              <span className={styles.filterFieldName}>
                {label}
              </span>
              <span className={styles.stars}>
                {[1, 2, 3, 4, 5].map((starNum) => (
                  <img
                    key={starNum}
                    src={
                      starNum <= (ratings[key]?.rating || 0) ? star : emptyStar
                    }
                    alt=""
                    className={styles.starIcon}
                    onClick={() =>
                      setRatings((prev) => ({
                        ...prev,
                        [key]: { ...prev[key], rating: starNum },
                      }))
                    }
                    style={{
                      cursor: "pointer",
                      width: 32,
                      height: 32,
                      marginRight: 4,
                    }}
                  />
                ))}
              </span>
            </div>
          ))}
        </div>
        <div>
          <span className={styles.filterlabels} style={{ marginTop: 16 }}>
            RM review
          </span>
          <textarea
            className={styles.textarea}
            rows={4}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
          />
        </div>
      </div>
    </SideDrawerOverlay>
  );
};

export default ReviewOverlay;
